module.exports = __webpack_public_path__ + "static/media/laundry-stacked-clothes.a9791ad5.png";